var React = require('react');

function Rows (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V5Zm-2 16H5v6h22v-6ZM5 13v6h22v-6H5Zm22-2V5H5v6h22Z"}));
}

Rows.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = Rows;

Rows.default = Rows;
